<template>
  <div>
    <div class="mt-6 mb-6">
      <div v-if="veiculos.length === 0">
        <vs-alert style="height: auto" active="true" color="danger">
          Nenhum Veículo Encontrado
        </vs-alert>
      </div>
      <div v-else>
        <vs-collapse
          type="border"
          icon-arrow="arrow_drop_down"
          color="primary"
          id="collapse-list-veiculos"
        >
          <div
            v-for="(
              grupoVeiculos, grupoNome, keyVeiculo
            ) in veiculosAgrupadosPorGrupo"
            :key="`${keyVeiculo}-${grupoNome}`"
          >
            <h3 class="p-4 text-2xl" style="color: let(--Text, #626262)">
              {{ grupoNome }}
            </h3>

            <vs-collapse-item
              class="item-collapse-produtos"
              v-for="{ veiculo: item, indexOriginal } in grupoVeiculos"
              :key="item.id"
            >
              <div
                slot="header"
                class="flex flex-row md:items-center justify-between gap-2"
              >
                <div class="flex flex-col gap-2 items-start">
                  <vs-chip
                    color="primary"
                    class="justify-center items-center px-2.5 py-1.5 rounded"
                  >
                    {{ item.placa ? item.placa : `Sem Placa - ${item.chassi}` }}
                  </vs-chip>
                  <strong class="text-sm font-semibold text-[#626262]">
                    {{
                      `${
                        item.veiculo.resultFipe.modelo || item.veiculo.modelo
                      } - ${
                        item.veiculo.resultFipe.ano ||
                        item.veiculo.anoFabricacao
                      }/${
                        item.veiculo.resultFipe.ano_modelo ||
                        item.veiculo.anoModelo
                      }`
                    }}
                  </strong>
                  <span
                    v-if="item.somenteAgregado"
                    class="font-normal text-[#626262]"
                  >
                    {{ `${item.veiculo.marca} / ${item.valorCobertura}` }}
                  </span>
                  <span v-else class="font-normal text-[#626262]">
                    {{
                      `${item.veiculo.resultFipe.fipe_codigo} / ${item.veiculo.resultFipe.combustivel}`
                    }}
                  </span>
                </div>
                <div class="flex items-center justify-end gap-3 mr-12">
                  <vs-button
                    radius
                    v-tooltip="'Editar'"
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="flex items-center justify-center p-2 w-10 h-10 rounded-full text-white"
                    @click.stop.prevent="
                      editClick(item, indexOriginal, indexAgregado)
                    "
                  ></vs-button>
                </div>
              </div>
              <div>
                <vs-row>
                  <vs-col class="mb-2 px-0" vs-lg="6" vs-sm="6" vs-xs="12">
                    <vs-list>
                      <vs-list-header
                        :title="$t('Produtos Obrigatórios')"
                        style="color: let(--Text, #626262); font-size: 1.25rem"
                      ></vs-list-header>
                      <ul class="centerx mt-6">
                        <li
                          v-for="produtoObrigatorio in item.produtosSelecionados"
                          :key="produtoObrigatorio.id_produto"
                          class="flex justify-between items-center mb-2"
                        >
                          <div
                            class="flex flex-col items-start"
                            v-if="
                              produtoObrigatorio.exibir &&
                              produtoObrigatorio.obrigatorio
                            "
                          >
                            <span class="text-[#626262] text-xs md:text-base">
                              {{ `${produtoObrigatorio.nomeProduto}` }}
                            </span>
                            <div class="flex justify-start">
                              <strong
                                :class="{
                                  'desconto-aplicado':
                                    produtoObrigatorio.descontoConcedido > 0,
                                }"
                                class="text-[#626262] text-xs md:text-base"
                              >
                                R$
                                {{ produtoObrigatorio.valor.toFixed(2) }}
                              </strong>

                              <strong
                                :class="`${
                                  produtoObrigatorio.descontoConcedido > 0
                                    ? 'block'
                                    : 'hidden'
                                } text-[#626262] text-xs`"
                              >
                                - R$
                                {{ produtoObrigatorio.valorFinal.toFixed(2) }}
                              </strong>
                              <strong
                                class="text-[#626262] text-xs md:text-base ml-1"
                              >
                                {{ produtoObrigatorio.ismensal ? '/mês' : '' }}
                              </strong>
                            </div>
                          </div>

                          <div
                            class="flex gap-2 items-center"
                            v-if="
                              produtoObrigatorio.exibir &&
                              produtoObrigatorio.obrigatorio
                            "
                          >
                            <vs-button
                              class="text-xs"
                              color="success"
                              v-if="
                                produtoObrigatorio.alterarValor &&
                                AlterarValorProduto
                              "
                              @click="
                                abrirFormNovoValor(
                                  produtoObrigatorio,
                                  indexOriginal,
                                )
                              "
                            >
                              +
                            </vs-button>
                            <vs-button
                              class="text-xs"
                              color="dark"
                              v-if="
                                produtoObrigatorio.porcentagemDescontoMaxima &&
                                isInterno &&
                                verificaPermissaoDescontoPorPerfil(
                                  produtoObrigatorio.idsPerfilDesconto,
                                )
                              "
                              @click="
                                exibePorcentagemDesconto(
                                  produtoObrigatorio,
                                  indexOriginal,
                                )
                              "
                            >
                              %
                            </vs-button>
                          </div>
                        </li>
                      </ul>
                    </vs-list>
                  </vs-col>
                  <vs-col class="mb-2 px-0" vs-lg="6" vs-sm="6" vs-xs="12">
                    <vs-list>
                      <vs-list-header
                        :title="$t('Produtos Opcionais')"
                        style="color: let(--Text, #626262); font-size: 1.25rem"
                      ></vs-list-header>
                      <ul class="centerx mt-6">
                        <li
                          v-for="(
                            produtoOpcional, key
                          ) in item.produtosNaoObrigatorios"
                          :key="`${key}-${produtoOpcional.id_produto}`"
                        >
                          <div
                            class="container px-0 flex items-center justify-start"
                            v-if="produtoOpcional.exibir"
                          >
                            <vs-checkbox
                              @input="
                                selecionaProduto(produtoOpcional, indexOriginal)
                              "
                              v-model="produtoOpcional.selecionado"
                              :vs-value="produtoOpcional.id_produto"
                            ></vs-checkbox>
                            <vs-list-item
                              style="
                                font-style: normal;
                                font-weight: 400;
                                font-size: 0.75rem;
                              "
                            >
                              <div class="flex flex-col gap-1">
                                <span class="text-[#626262] md:text-base">
                                  {{ `${produtoOpcional.nomeProduto}` }}
                                </span>
                                <strong class="md:text-base">
                                  R$ {{ produtoOpcional.valor.toFixed(2) }}
                                  {{ produtoOpcional.ismensal ? '/mês' : '' }}
                                </strong>
                              </div>
                            </vs-list-item>
                          </div>
                        </li>

                        <div :style="`${isInterno ? '' : 'display: none'}`">
                          <hr class="my-4" />
                          <h6 class="mt-5">
                            Total Mensal
                            {{ somaValorTotalMesAtualizados(item) | currency }}
                          </h6>
                          <h6 class="mt-5">
                            Total Entrada
                            {{ somaValorTotalAtualizados(item) | currency }}
                          </h6>
                          <hr class="my-2" />
                        </div>
                      </ul>
                    </vs-list>
                  </vs-col>
                </vs-row>
                <div
                  v-if="
                    item.agregado && item.agregados && item.agregados.length > 0
                  "
                >
                  <div
                    v-for="(agregado, indexAgregado) in item.agregados"
                    :key="indexAgregado"
                  >
                    <vs-row>
                      <vs-col class="mb-2" vs-lg="6" vs-sm="6" vs-xs="12">
                        <vs-list>
                          <vs-list-header
                            :title="`${$t(
                              'Produtos Obrigatórios',
                            )} - (Agregados)`"
                          ></vs-list-header>
                          <ul class="centerx mt-6">
                            <li
                              v-for="(
                                produtoObrigatorioAgregado, indexPoa
                              ) in agregado.produtosSelecionados"
                              :key="`agregado-${indexAgregado}-obrigatorio-${indexPoa}`"
                            >
                              <div
                                class="flex justify-between items-center"
                                v-if="produtoObrigatorioAgregado.obrigatorio"
                              >
                                <span class="text-[#626262] text-xs">
                                  {{
                                    `${produtoObrigatorioAgregado.nomeProduto} - `
                                  }}

                                  <span
                                    :class="{
                                      'desconto-aplicado':
                                        produtoObrigatorioAgregado.descontoConcedido >
                                        0,
                                    }"
                                    class="text-[#626262] text-xs ml-1"
                                  >
                                    R$
                                    {{
                                      produtoObrigatorioAgregado.valor.toFixed(
                                        2,
                                      )
                                    }}
                                  </span>

                                  <span
                                    :class="`${
                                      produtoObrigatorioAgregado.descontoConcedido >
                                      0
                                        ? 'block'
                                        : 'hidden'
                                    } text-[#626262] text-xs ml-1`"
                                  >
                                    - R$
                                    {{
                                      produtoObrigatorioAgregado.valorFinal.toFixed(
                                        2,
                                      )
                                    }}
                                  </span>
                                  <span class="text-[#626262] text-xs ml-1">
                                    {{
                                      produtoObrigatorioAgregado.ismensal
                                        ? '/mês'
                                        : ''
                                    }}
                                  </span>
                                </span>
                                <div class="flex items-center">
                                  <vs-button
                                    class="text-xs mr-2"
                                    color="success"
                                    v-if="
                                      produtoObrigatorioAgregado.alterarValor &&
                                      AlterarValorProduto
                                    "
                                    @click="
                                      abrirFormNovoValor(
                                        produtoObrigatorioAgregado,
                                        indexAgregado,
                                      )
                                    "
                                  >
                                    +
                                  </vs-button>
                                  <vs-button
                                    class="text-xs"
                                    color="dark"
                                    v-if="
                                      produtoObrigatorioAgregado.porcentagemDescontoMaxima &&
                                      isInterno &&
                                      verificaPermissaoDescontoPorPerfil(
                                        produtoObrigatorioAgregado.idsPerfilDesconto,
                                      )
                                    "
                                    @click="
                                      exibePorcentagemDesconto(
                                        produtoObrigatorioAgregado,
                                        indexOriginal,
                                        indexAgregado,
                                      )
                                    "
                                  >
                                    %
                                  </vs-button>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </vs-list>
                      </vs-col>
                      <vs-col class="mb-2" vs-lg="6" vs-sm="6" vs-xs="12">
                        <vs-list>
                          <vs-list-header
                            :title="`${$t('Produtos Opcionais')} - (Agregados)`"
                          ></vs-list-header>
                          <ul class="centerx mt-6">
                            <li
                              v-for="(
                                produtoOpcionalAgregado, indexPoa
                              ) in agregado.produtosNaoObrigatorios"
                              :key="`agregado-${indexAgregado}-opcional-${indexPoa}`"
                            >
                              <div
                                class="container flex items-center justify-start"
                              >
                                <vs-checkbox
                                  @input="
                                    selecionaProdutoAgregados(
                                      produtoOpcionalAgregado,
                                      indexOriginal,
                                      indexAgregado,
                                    )
                                  "
                                  v-model="produtoOpcionalAgregado.selecionado"
                                  :vs-value="produtoOpcionalAgregado.id_produto"
                                ></vs-checkbox>
                                <vs-list-item
                                  style="
                                    font-style: normal;
                                    font-weight: 400;
                                    font-size: 0.75rem;
                                  "
                                >
                                  <span class="text-[#626262]">{{
                                    produtoOpcionalAgregado.nomeProduto
                                  }}</span>
                                  <span> - </span>
                                  <strong
                                    >R$
                                    {{ produtoOpcionalAgregado.valor.toFixed(2)
                                    }}{{
                                      produtoOpcionalAgregado.ismensal
                                        ? '/mês'
                                        : ''
                                    }}</strong
                                  >
                                </vs-list-item>
                              </div>
                            </li>
                            <div :style="`${isInterno ? '' : 'display: none'}`">
                              <hr class="my-4" />
                              <h6 class="mt-5">
                                Total Mensal
                                {{
                                  somaValorTotalMesAtualizadosAgregado(agregado)
                                    | currency
                                }}
                              </h6>
                              <h6 class="mt-5">
                                Total Entrada
                                {{
                                  somaValorTotalAtualizadosAgregado(agregado)
                                    | currency
                                }}
                              </h6>
                              <hr class="my-2" />
                            </div>
                          </ul>
                        </vs-list>
                      </vs-col>
                    </vs-row>
                  </div>
                </div>
              </div>
            </vs-collapse-item>
          </div>
        </vs-collapse>
      </div>
    </div>
    <vs-popup class="holamundo" :title="titleSideBar" :active.sync="modalForm">
      <FormDesconto
        :key="contFormDesconto"
        :dados="itens"
        :contador="contFormDesconto"
        :modal="modalForm"
        :decoded="decoded"
        @salvarDesconto="salvarDesconto"
      >
      </FormDesconto>
    </vs-popup>
    <vs-popup
      id="meu-popup-personalizado"
      :title="'Novo Valor Produto'"
      :active.sync="mostrarModalNovoValorProduto"
    >
      <FormNovoValorProduto
        v-if="mostrarModalNovoValorProduto"
        :produto="novoValorProduto"
        :veiculoIndex="veiculoIndex"
        @produtoAtualizado="atualizarProduto"
        @close="mostrarModalNovoValorProduto = false"
      ></FormNovoValorProduto>
    </vs-popup>
    <ModalEditVeiculo
      :veiculoAtual="veiculoAtual"
      :veiculoIndex="veiculoIndex"
      ref="modalEditVeiculoRef"
      @update:veiculo="handleUpdateVeiculo"
    />
  </div>
</template>
<script>
import { TIPO_PRODUTO } from '../../../../../commons/dicionarioTipoProduto';
import {
  updateProdutoValorMensaliade,
  updateProdutoValorMinimoMensalidade,
} from '../../../../../services/propostas';
import functions from '../../../../../utils/functions';
import ModalEditVeiculo from './modalEditVeiculo.vue';
import FormDesconto from './formDesconto.vue';
import FormNovoValorProduto from '../../../../forms/FormNovoValorProduto.vue';
import { deepClone } from '../../../../../utils/deepClone';

export default {
  name: 'listVeiculos',
  props: {
    listVeiculosProposta: Array,
    decoded: Object,
  },
  components: { ModalEditVeiculo, FormDesconto, FormNovoValorProduto },
  watch: {
    veiculos: {
      handler() {
        if (!this.veiculos.length) return;
        this.somaValores();
        this.somaValoresAgregado();
      },
      deep: true,
    },
  },
  data() {
    return {
      veiculos: [],
      colorButton: this.$route.query.colorButton,
      veiculoAtual: null,
      isInterno: true,
      totalMensalidade: 0,
      totalEntrada: 0,
      novoValorProduto: {},
      mostrarModalNovoValorProduto: false,
      modalForm: false,
      contFormDesconto: 0,
      itens: null,
      produtos: [],
      produtoToDesconto: null,
      titleSideBar: 'Desconto',
      veiculoIndex: null,
      veiculosAgrupados: null,
      totalMensalidadeAgregado: 0,
      totalEntradaAgregado: 0,
      veiculoIndexAgregado: null,
    };
  },
  computed: {
    veiculosAgrupadosPorGrupo() {
      const grupos = {};
      this.veiculos.forEach((veiculo, indexOriginal) => {
        const grupoNome = veiculo.idGrupo.label;
        if (!grupos[grupoNome]) {
          grupos[grupoNome] = [];
        }
        grupos[grupoNome].push({ veiculo, indexOriginal });
      });
      return grupos;
    },
    AlterarValorProduto() {
      const bemProtege = this.verificaEmpresa();
      if (bemProtege) {
        return this.$can('Alterar Valor Produto', 'Cotações');
      } else {
        return false;
      }
    },
  },
  methods: {
    editClick(item, indexOriginal, indexAgregado = null) {
      this.veiculoAtual = item;
      this.veiculoIndex = indexOriginal;
      this.veiculoIndexAgregado = indexAgregado;
      this.$nextTick(() => {
        this.$refs.modalEditVeiculoRef.openModal();
      });
    },
    somaValores() {
      const veiculo = this.veiculos[this.veiculoIndex];
      this.totalMensalidade = this.somaValorTotalMesAtualizados(veiculo);
      updateProdutoValorMensaliade(
        veiculo.produtosSelecionados,
        this.totalMensalidade,
      );
      updateProdutoValorMinimoMensalidade(
        veiculo.produtosSelecionados,
        this.totalMensalidade,
      );
      this.totalEntrada = this.somaValorTotalAtualizados(veiculo);
    },
    somaValoresAgregado() {
      const agregado =
        this.veiculos[this.veiculoIndex].agregados[this.veiculoIndexAgregado];

      this.totalMensalidadeAgregado =
        this.somaValorTotalMesAtualizadosAgregado(agregado);
      updateProdutoValorMensaliade(
        agregado.produtosSelecionados,
        this.totalMensalidadeAgregado,
      );
      updateProdutoValorMinimoMensalidade(
        agregado.produtosSelecionados,
        this.totalMensalidadeAgregado,
      );
      this.totalEntradaAgregado =
        this.somaValorTotalMesAtualizadosAgregado(agregado);
    },
    somaValorTotalMesAtualizados(veiculo) {
      const totalValorTotalMesAtualizado = veiculo.produtosSelecionados
        .filter((prod) => prod.ismensal)
        .reduce((total, prod) => total + prod.valorFinal, 0);
      return totalValorTotalMesAtualizado;
    },
    somaValorTotalAtualizados(veiculo) {
      return veiculo.produtosSelecionados
        .filter((prod) => !prod.ismensal)
        .reduce((total, prod) => total + prod.valorFinal, 0);
    },
    somaValorTotalMesAtualizadosAgregado(agregado) {
      return agregado.produtosSelecionados
        .filter((prod) => prod.ismensal)
        .reduce((total, prod) => total + prod.valorFinal, 0);
    },
    somaValorTotalAtualizadosAgregado(agregado) {
      return agregado.produtosSelecionados
        .filter((prod) => !prod.ismensal)
        .reduce((total, prod) => total + prod.valorFinal, 0);
    },
    verificaEmpresa() {
      return functions.verificaEmpresaBemProtege(4);
    },
    verificaPermissaoDescontoPorPerfil(ids) {
      if (ids) {
        const arrayIds = ids.split(', ').map((id) => id.trim());
        return arrayIds.includes(this.decoded.id_perfil.toString());
      } else return this.$can('Pode oferecer desconto', 'Cotações');
    },
    exibePorcentagemDesconto(
      modelosFipeEncontrados,
      index,
      indexAgregado = null,
    ) {
      this.modalForm = true;

      this.veiculoIndex = index;
      this.veiculoIndexAgregado = indexAgregado;

      const _idEmpresa = !this.$route.params.idEmpresa
        ? this.veiculos.idEmpresa
        : this.$route.params.idEmpresa;

      this.contFormDesconto = this.contFormDesconto + 1;

      if (this.modalForm) {
        this.itens = modelosFipeEncontrados;
        this.itens.estado = this.veiculos[index].estado;
        this.itens.tipoProposta = this.veiculos[index].tipoProposta;
        this.itens.indexAgregado = indexAgregado;
        this.itens.idEmpresa = _idEmpresa;
        this.itens.nomeGrupo = this.veiculos[index].idGrupo.label;
        this.itens.precoVeiculo = this.veiculos[index].precoVeiculo;
        this.itens.idEmpresa = this.veiculos[index].idEmpresa;
      }
    },
    salvarDesconto(data) {
      const veiculo = this.veiculos[this.veiculoIndex];

      const agregado =
        this.veiculos[this.veiculoIndex].agregados[data.indexAgregado];
      const produtoIndex = veiculo.produtosSelecionados.findIndex(
        (p) => p.id === data.id_produto,
      );

      const existeProduto = produtoIndex !== -1;
      if (existeProduto) {
        const produto = veiculo.produtosSelecionados[produtoIndex];
        produto.style =
          data.valorDesconto === 0 ? null : 'text-decoration: line-through';
        produto.isDesconto = data.valorDesconto !== 0;
        this.somaValores();
      }
      if (agregado) {
        const produto = agregado.produtosSelecionados[produtoIndex];
        produto.style =
          data.valorDesconto === 0 ? null : 'text-decoration: line-through';
        produto.isDesconto = data.valorDesconto !== 0;
        this.somaValoresAgregado();
      }

      this.modalForm = false;
      this.veiculoIndex = null;
      this.veiculoIndexAgregado = null;
    },
    async selecionaProduto(produto, index) {
      const veiculo = this.veiculos[index];
      this.veiculoIndex = index;
      const produtoEncontrado = veiculo.produtosSelecionados.find(
        ({ id }) => String(id) === String(produto.id),
      );
      const estaRetirando = Boolean(produtoEncontrado);
      if (!estaRetirando) {
        veiculo.produtosSelecionados.push(produto);
        const opcional = veiculo.produtosNaoObrigatorios.find(
          (itemProduto) => itemProduto.id === produto.id,
        );
        opcional.selecionado = true;

        const linkados = produto.produtosLinkados
          .split(',')
          .map((id) => Number(id));
        const produtosLinkadosAInserir = veiculo.produtos.filter(
          (itemProduto) =>
            linkados.some((linkado) => linkado === itemProduto.id),
        );
        veiculo.produtosNaoObrigatorios.forEach((itemProduto) => {
          if (linkados.some((linkado) => linkado === itemProduto.id)) {
            itemProduto.selecionado = true;
          }
        });

        veiculo.produtosSelecionados.push(...produtosLinkadosAInserir);

        const sobrepostos = produto.sobreporOutrosProdutos
          .split(',')
          .map((id) => Number(id));
        veiculo.produtosSelecionados = [
          ...veiculo.produtosSelecionados.filter(
            (itemProduto) =>
              !sobrepostos.some((sobreposto) => sobreposto === itemProduto.id),
          ),
        ];

        veiculo.produtosNaoObrigatorios.forEach((itemProduto) => {
          if (sobrepostos.some((linkado) => linkado === itemProduto.id)) {
            itemProduto.selecionado = false;
          }
        });

        const ehCasco =
          produto.id_tipoProduto === TIPO_PRODUTO.TIPO_PRODUTO_CASCO;

        if (ehCasco) {
          const complementares = produto.produtosComplementares
            .split(',')
            .map((id) => Number(id));

          veiculo.produtosNaoObrigatorios.forEach((itemProduto) => {
            const ehParaAtivar = complementares.some(
              (complementar) => complementar === itemProduto.id,
            );
            if (ehParaAtivar) {
              itemProduto.exibir = true;
            }
          });
        }
        veiculo.produtosObrigatorios.forEach((produtoObrigatorio) => {
          const estaSelecionado = veiculo.produtosSelecionados.some(
            (produtoSelecionado) =>
              String(produtoSelecionado.id) === String(produtoObrigatorio.id),
          );

          if (!estaSelecionado) {
            produtoObrigatorio.exibir = false;
          }
        });
        this.somaValores();
        this.veiculoIndex = null;
        return;
      }
      veiculo.produtosSelecionados = [
        ...veiculo.produtosSelecionados.filter(
          ({ id }) => String(id) !== String(produtoEncontrado.id),
        ),
      ];

      const opcional = veiculo.produtosNaoObrigatorios.find(
        (itemProduto) => itemProduto.id === produto.id,
      );
      opcional.selecionado = false;

      const linkados = produto.produtosLinkados
        .split(',')
        .map((id) => Number(id));

      veiculo.produtosSelecionados = [
        ...veiculo.produtosSelecionados.filter(
          (itemProduto) =>
            !linkados.some((linkado) => linkado === itemProduto.id),
        ),
      ];

      veiculo.produtosNaoObrigatorios.forEach((itemProduto) => {
        if (linkados.some((linkado) => linkado === itemProduto.id)) {
          itemProduto.selecionado = false;
        }
      });

      const temSobreposto = Boolean(produto.sobreporOutrosProdutos.length);

      if (temSobreposto) {
        const sobrepostos = produto.sobreporOutrosProdutos
          .split(',')
          .map((id) => Number(id));

        veiculo.produtosObrigatorios.forEach((itemProduto) => {
          const isSobreposto = sobrepostos.some(
            (sobreposto) => sobreposto === itemProduto.id,
          );
          const notInProdutosSelecionados = !veiculo.produtosSelecionados.some(
            (produto) => produto.id === itemProduto.id,
          );

          if (isSobreposto && notInProdutosSelecionados) {
            veiculo.produtosSelecionados.push(itemProduto);
            itemProduto.selecionado = true;
            itemProduto.exibir = true;
          }
        });
      }

      const ehCasco =
        produto.id_tipoProduto === TIPO_PRODUTO.TIPO_PRODUTO_CASCO;

      if (ehCasco) {
        const complementares = produto.produtosComplementares
          .split(',')
          .map((id) => Number(id));
        veiculo.produtosNaoObrigatorios.forEach((itemProduto) => {
          const ehParaDesativar = complementares.some(
            (complementar) => complementar === itemProduto.id,
          );
          if (ehParaDesativar) {
            itemProduto.exibir = false;
            itemProduto.selecionado = false;
          }
        });
        veiculo.produtosSelecionados = [
          ...veiculo.produtosSelecionados.filter(
            (itemProduto) =>
              !complementares.some(
                (complementar) => complementar === itemProduto.id,
              ),
          ),
        ];
      }

      veiculo.produtosObrigatorios.forEach((produtoObrigatorio) => {
        const estaSelecionado = veiculo.produtosSelecionados.some(
          (itemProduto) =>
            String(itemProduto.id) === String(produtoObrigatorio.id),
        );

        if (!estaSelecionado) {
          produtoObrigatorio.exibir = true;
        }
      });
      this.somaValores();
      this.veiculoIndex = null;
    },
    async selecionaProdutoAgregados(produto, indexVeiculo, indexAgregado) {
      const agregado = this.veiculos[indexVeiculo].agregados[indexAgregado];
      this.veiculoIndex = indexVeiculo;
      this.veiculoIndexAgregado = indexAgregado;
      const produtoEncontrado = agregado.produtosSelecionados.find(({ id }) => {
        return String(id) === String(produto.id);
      });

      const estaRetirando = Boolean(produtoEncontrado);
      if (!estaRetirando) {
        agregado.produtosSelecionados.push(produto);
        const opcional = agregado.produtosNaoObrigatorios.find(
          (itemProduto) => itemProduto.id === produto.id,
        );
        opcional.selecionado = true;

        const linkados = produto.produtosLinkados
          .split(',')
          .map((id) => Number(id));
        const produtosLinkadosAInserir = agregado.produtos.filter(
          (itemProduto) =>
            linkados.some((linkado) => linkado === itemProduto.id),
        );
        agregado.produtosNaoObrigatorios.forEach((itemProduto) => {
          if (linkados.some((linkado) => linkado === itemProduto.id)) {
            itemProduto.selecionado = true;
          }
        });

        agregado.produtosSelecionados.push(...produtosLinkadosAInserir);

        const sobrepostos = produto.sobreporOutrosProdutos
          .split(',')
          .map((id) => Number(id));
        agregado.produtosSelecionados = [
          ...agregado.produtosSelecionados.filter(
            (itemProduto) =>
              !sobrepostos.some((sobreposto) => sobreposto === itemProduto.id),
          ),
        ];

        agregado.produtosNaoObrigatorios.forEach((itemProduto) => {
          if (sobrepostos.some((linkado) => linkado === itemProduto.id)) {
            itemProduto.selecionado = false;
          }
        });

        const ehCasco =
          produto.id_tipoProduto === TIPO_PRODUTO.TIPO_PRODUTO_CASCO;

        if (ehCasco) {
          const complementares = produto.produtosComplementares
            .split(',')
            .map((id) => Number(id));

          agregado.produtosNaoObrigatorios.forEach((itemProduto) => {
            const ehParaAtivar = complementares.some(
              (complementar) => complementar === itemProduto.id,
            );
            if (ehParaAtivar) {
              itemProduto.exibir = true;
            }
          });
        }
        this.somaValoresAgregado();
        this.veiculoIndex = null;
        this.veiculoIndexAgregado = null;
        return;
      }
      agregado.produtosSelecionados = [
        ...agregado.produtosSelecionados.filter(
          ({ id }) => String(id) !== String(produtoEncontrado.id),
        ),
      ];

      const opcional = agregado.produtosNaoObrigatorios.find(
        (itemProduto) => itemProduto.id === produto.id,
      );
      opcional.selecionado = false;

      const linkados = produto.produtosLinkados
        .split(',')
        .map((id) => Number(id));

      agregado.produtosSelecionados = [
        ...agregado.produtosSelecionados.filter(
          (itemProduto) =>
            !linkados.some((linkado) => linkado === itemProduto.id),
        ),
      ];

      agregado.produtosNaoObrigatorios.forEach((itemProduto) => {
        if (linkados.some((linkado) => linkado === itemProduto.id)) {
          itemProduto.selecionado = false;
        }
      });
      const temSobreposto = Boolean(produto.sobreporOutrosProdutos.length);

      if (temSobreposto) {
        const sobrepostos = produto.sobreporOutrosProdutos
          .split(',')
          .map((id) => Number(id));

        agregado.produtosObrigatorios.forEach((itemProduto) => {
          const isSobreposto = sobrepostos.some(
            (sobreposto) => sobreposto === itemProduto.id,
          );
          const notInProdutosSelecionados = !agregado.produtosSelecionados.some(
            (produto) => produto.id === itemProduto.id,
          );

          if (isSobreposto && notInProdutosSelecionados) {
            agregado.produtosSelecionados.push(itemProduto);
            itemProduto.selecionado = true;
            itemProduto.exibir = true;
          }
        });
      }

      const ehCasco =
        produto.id_tipoProduto === TIPO_PRODUTO.TIPO_PRODUTO_CASCO;

      if (ehCasco) {
        const complementares = produto.produtosComplementares
          .split(',')
          .map((id) => Number(id));

        agregado.produtosNaoObrigatorios.forEach((itemProduto) => {
          const ehParaDesativar = complementares.some(
            (complementar) => complementar === itemProduto.id,
          );
          if (ehParaDesativar) {
            itemProduto.exibir = false;
            itemProduto.selecionado = false;
          }
        });
        agregado.produtosSelecionados = [
          ...agregado.produtosSelecionados.filter(
            (itemProduto) =>
              !complementares.some(
                (complementar) => complementar === itemProduto.id,
              ),
          ),
        ];
      }
      this.somaValoresAgregado();
      this.veiculoIndex = null;
      this.veiculoIndexAgregado = null;
    },
    async handleUpdateVeiculo(updatedVeiculo, index) {
      this.$set(this.veiculos, index, updatedVeiculo);
    },
    abrirFormNovoValor(produto, indexVeiculo) {
      this.novoValorProduto = produto;
      this.veiculoIndex = indexVeiculo;
      this.mostrarModalNovoValorProduto = true;
    },
    atualizarProduto(produtoAtualizado, indexVeiculo) {
      const agregado = this.veiculos[indexVeiculo];

      const indiceProduto = agregado.produtos.findIndex(
        (p) => p.id === produtoAtualizado.id,
      );
      if (indiceProduto !== -1) {
        agregado.produtos[indiceProduto] = produtoAtualizado;

        const indiceProdutoSelecionado =
          agregado.produtosSelecionados.findIndex(
            (p) => p.id === produtoAtualizado.id,
          );
        if (indiceProdutoSelecionado !== -1) {
          agregado.produtosSelecionados[indiceProdutoSelecionado].valorFinal =
            produtoAtualizado.valorFinal;
        }
      }
      this.$set(this.veiculos, indexVeiculo, agregado);
    },
    onSubmit() {
      const copiaVeiculos = deepClone(this.veiculos);
      this.$emit('submitDadosVeiculos', copiaVeiculos);
      // this.$emit('submitDadosVeiculos', this.veiculos);
      return true;
    },
  },
  async mounted() {
    this.veiculos = [];
    // this.veiculos = await this.listVeiculosProposta.map((veiculo) => ({
    //   ...veiculo,
    //   changeValorMinimoMensalidade: false,
    // }));
    this.veiculos = await this.listVeiculosProposta.map((veiculo) => {
      const veiculoAtualizado = {
        ...veiculo,
        changeValorMinimoMensalidade: false,
      };
      if (veiculoAtualizado.agregados && veiculoAtualizado.agregados.length) {
        veiculoAtualizado.agregados = veiculoAtualizado.agregados.map(
          (agregado) => ({
            ...agregado,
            changeValorMinimoMensalidade: false,
          }),
        );
      }
      return veiculoAtualizado;
    });
    this.veiculos = deepClone(this.listVeiculosProposta);

    this.veiculos.forEach((veiculo, index) => {
      this.veiculoIndex = index;
      this.somaValores();
      if (veiculo.agregados.length) this.somaValoresAgregado();
    });
    const companyId = this.decoded.id_empresa;
    this.$i18n.locale = functions.setLocaleBasedOnCompany(Number(companyId));
  },
};
</script>

<style lang="css">
.item-collapse-produtos .vs-collapse-item--icon-header .vs-icon {
  background: rgba(var(--vs-primary), 1);
  border-radius: 50%;
  font-size: 15px;
  padding: 10px;
  color: white;
}

.item-collapse-produtos.open-item .vs-collapse-item--content {
  max-height: fit-content !important;
}
.desconto-aplicado {
  text-decoration: line-through;
}
</style>
